module.exports = __webpack_public_path__ + "media/images/email/ic_selected-fc091ab82946d55f2cbfe311da961c8d.svg";